import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const IdKaartIcon: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="IdKaart" width={width} height={height} alt="iconIdKaart" ignoreRtl {...rest} />
)
